import { render, staticRenderFns } from "./CheckboxResponseType.vue?vue&type=template&id=529f41bb&lang=pug"
import script from "./CheckboxResponseType.vue?vue&type=script&lang=js"
export * from "./CheckboxResponseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports